import { render, staticRenderFns } from "./RevisionConfirm.vue?vue&type=template&id=a6522210"
import script from "./RevisionConfirm.vue?vue&type=script&lang=js"
export * from "./RevisionConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports